
import { NoseurObject } from "@rivtn/noseur";
import { Actor, SanitizedResponse } from "../BaseService";
import { ConfigurationType, PloutousBaseService } from "./PloutousBaseService";

export interface IPlatformConfiguration {
    value: any;
    key: string;
    status: string;
    created_by: Actor;
    updated_by: Actor;
    created_at: string;
    updated_at: string;
    description: string;
    external_id: string;
    type: ConfigurationType;
}

export class PlatformConfigurationService extends PloutousBaseService {

    protected static instance: PlatformConfigurationService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!PlatformConfigurationService.instance) PlatformConfigurationService.instance = new PlatformConfigurationService();
        return PlatformConfigurationService.instance;
    }

    queryPlatformConfigurations(params: NoseurObject<string | number> = { page: 1, size: 10 }): Promise<SanitizedResponse<IPlatformConfiguration>> {
        return this.report(this.transport.get("/api/v1/platform/configuration", { query: this.normalizeParams(params) }));
    }

    createPlatformConfiguration(payload: any): Promise<SanitizedResponse<IPlatformConfiguration>> {
        return this.report(this.transport.post(`/api/v1/platform/configuration`, payload));
    }

    updatePlatformConfiguration(payload: Partial<IPlatformConfiguration>): Promise<SanitizedResponse<IPlatformConfiguration>> {
        const id = payload.external_id; delete payload.external_id;
        return this.report(this.transport.patch(`/api/v1/platform/configuration/${id}`, payload));
    }

    deletePlatformConfiguration(id: string): Promise<SanitizedResponse<IPlatformConfiguration>> {
        return this.report(this.transport.delete(`/api/v1/platform/configuration/${id}`));
    }

}
